@if (largeView) {
  <div class="d-flex gap-2 flex-wrap p-2">
    <button
      (click)="onDateSelect('week', '-')"
      class="btn btn-lg btn-secondary px-5"
      title="previous"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
    >
      <i class="fa-solid fa-backward"></i>
    </button>
    <div
      class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-2 form-control justify-content-center fw-semibold w-auto"
      role="button"
    >
      <span
        >{{ shiftWeekDays[0] | customDate: "d MMM y" }} -
        {{
          shiftWeekDays[shiftWeekDays?.length - 1] | customDate: "d MMM y"
        }}</span
      >
      <span><i class="fa-solid fa-calendar ms-1"></i></span>

      <input
        class="hidden-calendar-lookup"
        type="date"
        [(ngModel)]="selectedSearchDate"
        (change)="onDateSelect('search', '=')"
      />
    </div>
    <button
      (click)="onDateSelect('week', '+')"
      class="btn btn-lg btn-secondary px-5"
      title="next"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
    >
      <i class="fa-solid fa-forward"></i>
    </button>

    @if (isAdmin || isDispatchUser) {
      <div>
        <div
          class="d-flex fw-semibold align-items-center justify-content-center mb-1 text-uppercase small text-secondary gap-5"
        >
          <div class="d-flex align-items-center">Group / Sort</div>
          <div class="d-flex align-items-center" (click)="onExpandView()">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="expandAllGroups"
            />
            <div
              role="button"
              class="ms-1"
              [ngClass]="expandAllGroups ? 'text-body fw-bold' : ''"
            >
              Expand All
              <i
                class="fa-solid fa-up-right-and-down-left-from-center ms-1"
              ></i>
            </div>
          </div>
        </div>
        <div class="d-flex btn-group">
          <button
            title="Client"
            class="btn fw-semibold px-4"
            [ngClass]="
              shiftDataGroupBy === 'company'
                ? 'btn-danger'
                : 'btn-outline-primary bg-white'
            "
            (click)="changeShiftGroupBy('company')"
          >
            <i class="fa-solid fa-building"></i>
          </button>
          <button
            title="Site"
            class="btn fw-semibold px-4"
            [ngClass]="
              shiftDataGroupBy === 'site'
                ? 'btn-danger'
                : 'btn-outline-primary bg-white'
            "
            (click)="changeShiftGroupBy('site')"
          >
            <i class="fa-solid fa-location-dot"></i>
          </button>
          @if (isAdmin || isDispatchUser) {
            <button
              title="Person"
              class="btn fw-semibold px-4"
              [ngClass]="
                shiftDataGroupBy === 'assignee'
                  ? 'btn-danger'
                  : 'btn-outline-primary bg-white'
              "
              (click)="changeShiftGroupBy('assignee')"
            >
              <i class="fa-regular fa-circle-user"></i>
            </button>
          }
          @if (isAdmin || isDispatchUser) {
            <button
              title="Hour"
              class="btn fw-semibold px-4"
              [ngClass]="
                shiftDataGroupBy === 'time'
                  ? 'btn-danger'
                  : 'btn-outline-primary bg-white'
              "
              (click)="changeShiftGroupBy('time')"
            >
              <i class="fa-regular fa-clock"></i>
            </button>
          }
        </div>
      </div>
    }

    @if (isAdmin || isDispatchUser) {
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="smallFloatingInputGroup"
          placeholder="Filters"
          (click)="openTemplate(searchTemplateRef)"
        />
        <label for="smallFloatingInputGroup">Filters</label>
      </div>
    }
    @if (shiftStatus?.unassigned_shifts && (isAdmin || isDispatchUser)) {
      <div
        role="button"
        class="d-flex align-items-center fw-bold small text-danger text-uppercase px-2 pb-2"
        (click)="redirectToPage('unAssignedJobs')"
      >
        Unassigned
      </div>
    }
    @if (
      (conflictData | misc: "getDictKeys")?.length &&
      (isAdmin || isDispatchUser)
    ) {
      <div
        role="button"
        (click)="openTemplate(conflictShiftListTemplate)"
        class="d-flex align-items-center fw-bold small text-danger text-uppercase px-2 pb-2"
      >
        Conflicts
      </div>
    }
    @if (shiftsToPublishListFiltered?.length && (isAdmin || isDispatchUser)) {
      <div class="form-floating">
        <button
          id="publishShiftBtn"
          class="btn btn-lg btn-success"
          (click)="sendShiftEmailAlert(sendShiftNotificationTemplate)"
        >
          Publish Shifts
        </button>
      </div>
    }
  </div>

  @if ((appliedFilters | misc: "getDictKeys")?.length) {
    <div class="d-flex align-items-center gap-2 p-2">
      @if (appliedFilters?.jType?.id) {
        <button class="btn btn-outline-danger small d-flex align-items-center">
          <span> Job Type: {{ appliedFilters?.jType?.name }}</span>
          <span
            class="ms-4"
            (click)="appliedFilters.jType = {}; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if (appliedFilters?.client?.id) {
        <button class="btn btn-outline-danger small d-flex align-items-center">
          <span> Client: {{ appliedFilters?.client?.company_name }}</span>
          <span
            class="ms-4"
            (click)="appliedFilters.client = {}; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if (appliedFilters?.site?.id) {
        <button class="btn btn-outline-danger small d-flex align-items-center">
          <span> Site: {{ appliedFilters?.site?.company_name }}</span>
          <span
            class="ms-4"
            (click)="appliedFilters.site = {}; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if (appliedFilters?.assignee?.id) {
        <button class="btn btn-outline-danger small d-flex align-items-center">
          <span> Assignee: {{ appliedFilters?.assignee?.full_name }}</span>
          <span
            class="ms-4"
            (click)="appliedFilters.assignee = {}; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if (appliedFilters?.time?.id) {
        <button class="btn btn-outline-danger small d-flex align-items-center">
          <span> Hour: {{ appliedFilters?.time?.full_name }}</span>
          <span
            class="ms-4"
            (click)="appliedFilters.time = {}; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if (appliedFilters?.shiftStatus) {
        <button class="btn btn-danger small d-flex align-items-center">
          <span>
            Shift Status:
            {{
              appliedFilters?.shiftStatus === 1
                ? "Assigned"
                : appliedFilters?.shiftStatus === 2
                  ? "Pending"
                  : "Unassigned"
            }}</span
          >
          <span
            class="ms-4"
            (click)="appliedFilters.shiftStatus = 0; filterRosterShifts()"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </button>
      }
      @if ((appliedFilters | misc: "getDictKeys")?.length) {
        <button
          class="btn btn-danger small d-flex align-items-center"
          (click)="appliedFilters = {}; filterRosterShifts()"
        >
          Clear Filters
        </button>
      }
    </div>
  }

  <ng-container>
    <div class="roster-table">
      <table>
        <thead>
          <tr>
            @for (date of shiftWeekDays; track date; let i = $index) {
              <th class="align-top">
                @if (
                  (isAdmin || isDispatchUser) && date
                    | misc: "addRosterShiftDateCheck"
                ) {
                  <div
                    class="weekday mb-2"
                    role="button"
                    id="addRoster"
                    (click)="onAddShiftClick(date)"
                  >
                    <div>
                      <div>
                        {{ date | date: "yyyy-MM-dd" }}
                      </div>
                      <div>
                        {{ date | misc: "getWeekDay" }}
                      </div>
                    </div>
                    <div class="addJob">+</div>
                  </div>
                } @else {
                  <div class="weekday mb-2">
                    <div>
                      <div>
                        {{ date | date: "yyyy-MM-dd" }}
                      </div>
                      <div>
                        {{ date | misc: "getWeekDay" }}
                      </div>
                    </div>
                  </div>
                }
                <ng-template
                  *ngTemplateOutlet="weatherTemplate; context: { date: date }"
                ></ng-template>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @if (expandAllGroups) {
            @for (grpId of groupByIds; track grpId) {
              <tr>
                @for (date of shiftWeekDays; track date) {
                  <td>
                    @if (
                      (
                        fullGroupedRosterData
                        | misc: "rosterShiftDictEventDateData" : date
                      )?.length
                    ) {
                      @for (
                        job of fullGroupedRosterData
                          | misc: "rosterShiftDictEventDateData" : date;
                        track job;
                        let i = $index
                      ) {
                        <div>
                          <!--group by header-->
                          @if (
                            job[
                              shiftDataGroupBy === "time"
                                ? "time_id"
                                : shiftDataGroupBy === "site"
                                  ? "site_uuid"
                                  : shiftDataGroupBy === "company"
                                    ? "company_uuid"
                                    : shiftDataGroupBy === "assignee"
                                      ? "assignee_id"
                                      : ""
                            ] === grpId ||
                            (grpId == "checkpointPatrol" &&
                              job?.job_type_dict?.type_identity === 4)
                          ) {
                            @if (
                              i === 0 ||
                              job[
                                shiftDataGroupBy === "time"
                                  ? "time_id"
                                  : shiftDataGroupBy === "site"
                                    ? "site_uuid"
                                    : shiftDataGroupBy === "company"
                                      ? "company_uuid"
                                      : shiftDataGroupBy === "assignee"
                                        ? "assignee_id"
                                        : ""
                              ] !==
                                (fullGroupedRosterData
                                  | misc
                                    : "rosterShiftDictEventDateData"
                                    : date)?.[i - 1][
                                  shiftDataGroupBy === "time"
                                    ? "time_id"
                                    : shiftDataGroupBy === "site"
                                      ? "site_uuid"
                                      : shiftDataGroupBy === "company"
                                        ? "company_uuid"
                                        : shiftDataGroupBy === "assignee"
                                          ? "assignee_id"
                                          : ""
                                ]
                            ) {
                              <div class="mb-2 fw-semibold fs-6 d-flex">
                                <div
                                  class="flex-grow-1 group-by"
                                  role="button"
                                  (click)="filterDataByGroupByField(job)"
                                >
                                  @if (shiftDataGroupBy === "assignee") {
                                    <span
                                      [class.text-danger]="
                                        job?.assignee_id === 'unassigned'
                                      "
                                    >
                                      {{ job?.assignee_name }}
                                    </span>
                                  } @else if (shiftDataGroupBy === "time") {
                                    {{ job?.time_id }}
                                  } @else if (
                                    job?.job_type_dict?.type_identity === 4
                                  ) {
                                    {{ job?.job_type_dict?.name }}
                                  } @else if (shiftDataGroupBy === "site") {
                                    <div>
                                      <span class="fw-semibold"
                                        >{{ job?.site_name }}
                                      </span>
                                      <div class="text-secondary small">
                                        {{ job?.company_name }}
                                      </div>
                                    </div>
                                  } @else if (shiftDataGroupBy === "company") {
                                    {{ job?.company_name }}
                                  }
                                </div>
                                @if (shiftDataGroupBy !== "assignee") {
                                  <div class="text-primary me-2">
                                    {{
                                      (groupCountsByDate
                                        | misc
                                          : "rosterShiftDictEventDateData"
                                          : date)[
                                        job[
                                          shiftDataGroupBy === "time"
                                            ? "time_id"
                                            : shiftDataGroupBy === "site"
                                              ? "site_uuid"
                                              : shiftDataGroupBy === "company"
                                                ? "company_uuid"
                                                : shiftDataGroupBy ===
                                                    "assignee"
                                                  ? "assignee_id"
                                                  : ""
                                        ] || "checkpointPatrol"
                                      ]
                                    }}
                                  </div>
                                }
                              </div>
                            }
                            <!--job-details-->
                            <ng-template
                              *ngTemplateOutlet="
                                jobDetailTemplate;
                                context: { job: job, date: date }
                              "
                            ></ng-template>
                          }
                        </div>
                      }
                    }
                  </td>
                }
              </tr>
            }
          } @else {
            @for (groupedData of groupedDataList; track groupedData) {
              <tr>
                @if (selectedGroupInfo?.grouped_id == groupedData?.grouped_id) {
                  @for (date of shiftWeekDays; track date) {
                    <td>
                      @if (
                        (
                          fullGroupedRosterData
                          | misc: "rosterShiftDictEventDateData" : date
                        )?.length
                      ) {
                        @for (
                          job of fullGroupedRosterData
                            | misc: "rosterShiftDictEventDateData" : date;
                          track job;
                          let i = $index
                        ) {
                          <div>
                            @if (
                              i === 0 ||
                              job[
                                shiftDataGroupBy === "time"
                                  ? "time_id"
                                  : shiftDataGroupBy === "site"
                                    ? "site_uuid"
                                    : shiftDataGroupBy === "company"
                                      ? "company_uuid"
                                      : shiftDataGroupBy === "assignee"
                                        ? "assignee_id"
                                        : ""
                              ] !==
                                (fullGroupedRosterData
                                  | misc
                                    : "rosterShiftDictEventDateData"
                                    : date)?.[i - 1][
                                  shiftDataGroupBy === "time"
                                    ? "time_id"
                                    : shiftDataGroupBy === "site"
                                      ? "site_uuid"
                                      : shiftDataGroupBy === "company"
                                        ? "company_uuid"
                                        : shiftDataGroupBy === "assignee"
                                          ? "assignee_id"
                                          : ""
                                ]
                            ) {
                              <div class="mb-2 fw-semibold fs-6 d-flex">
                                <div class="flex-grow-1" role="button">
                                  @if (shiftDataGroupBy === "assignee") {
                                    <span
                                      [class.text-danger]="
                                        job?.assignee_id === 'unassigned'
                                      "
                                    >
                                      {{ job?.assignee_name }}
                                    </span>
                                  } @else if (shiftDataGroupBy === "time") {
                                    {{ job?.time_id }}
                                  } @else if (
                                    job?.job_type_dict?.type_identity === 4
                                  ) {
                                    {{ job?.job_type_dict?.name }}
                                  } @else if (shiftDataGroupBy === "site") {
                                    <div>
                                      <span class="fw-semibold"
                                        >{{ job?.site_name }}
                                      </span>
                                      <div class="text-secondary small">
                                        {{ job?.company_name }}
                                      </div>
                                    </div>
                                  } @else if (shiftDataGroupBy === "company") {
                                    {{ job?.company_name }}
                                  }
                                </div>
                                @if (shiftDataGroupBy !== "assignee") {
                                  <div class="text-primary me-2">
                                    {{
                                      (groupCountsByDate
                                        | misc
                                          : "rosterShiftDictEventDateData"
                                          : date)[
                                        job[
                                          shiftDataGroupBy === "time"
                                            ? "time_id"
                                            : shiftDataGroupBy === "site"
                                              ? "site_uuid"
                                              : shiftDataGroupBy === "company"
                                                ? "company_uuid"
                                                : shiftDataGroupBy ===
                                                    "assignee"
                                                  ? "assignee_id"
                                                  : ""
                                        ] || "checkpointPatrol"
                                      ]
                                    }}
                                  </div>
                                }
                              </div>
                            }
                            <!--job-details-->
                            <ng-template
                              *ngTemplateOutlet="
                                jobDetailTemplate;
                                context: { job: job, date: date }
                              "
                            ></ng-template>
                          </div>
                        }
                      }
                    </td>
                  }
                } @else {
                  <td (click)="getGroupedDataJobList(groupedData)">
                    <div
                      role="button"
                      class="group-by fs-6 border-top border-bottom px-1 border-2 py-2 d-flex align-items-center"
                      [class.text-danger]="
                        groupedData?.grouped_id === 'unassigned'
                      "
                    >
                      <div class="fw-semibold">
                        {{ groupedData?.grouped_name }}
                      </div>
                      @if (groupedData?.company_name) {
                        <div class="text-secondary small ms-1">
                          [{{ groupedData?.company_name }}]
                        </div>
                      }
                      <div class="ms-auto">
                        <i
                          class="fa-solid fa-up-right-and-down-left-from-center"
                        ></i>
                      </div>
                    </div>
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </ng-container>
} @else {
  <div id="date-selection" class="d-flex gap-2 flex-wrap pb-2">
    @if (selectedSearchDate) {
      <div class="flex-grow-1">
        <div
          class="position-relative bg-white border text-dark text-center rounded d-flex align-items-center p-2 form-control justify-content-center fw-semibold"
          role="button"
        >
          <span
            >{{ shiftWeekDays[0] | customDate: "d MMM y" }} -
            {{
              shiftWeekDays[shiftWeekDays?.length - 1] | customDate: "d MMM y"
            }}</span
          >
          <span><i class="fa-solid fa-calendar ms-1"></i></span>

          <input
            class="hidden-calendar-lookup"
            type="date"
            [(ngModel)]="selectedSearchDate"
            (change)="onDateSelect('search', '=')"
          />
        </div>
      </div>
    }

    <div
      (click)="onDateSelect('week', '-')"
      class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
      role="button"
    >
      <i class="fas fa-angle-left"></i>
    </div>

    <div
      (click)="onDateSelect('week', '+')"
      class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
    >
      <i class="fas fa-angle-right"></i>
    </div>

    @if (!isCurrentWeek) {
      <div
        (click)="onDateSelect('week', '=')"
        class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button small fw-medium p-2"
        role="button"
      >
        Today
      </div>
    }
  </div>

  <div id="rosterJobList" class="scrollable-mobile pb-5">
    @if (!(fullGroupedRosterData | misc: "getDictKeys")?.length) {
      <div class="centered">
        <div class="alert alert-secondary">
          Nothing rostered for this period
        </div>
      </div>
    }
    @for (date of shiftWeekDays; track date) {
      @let pastShift = date | misc: "isPastScheduleCheck";

      @for (
        job of fullGroupedRosterData
          | misc: "rosterShiftDictEventDateData" : date;
        track job
      ) {
        <div [class.opacity-50]="pastShift">
          <ng-template
            *ngTemplateOutlet="
              jobDetailTemplate;
              context: { job: job, date: date }
            "
          ></ng-template>
        </div>
      }
    }
  </div>
}

<ng-template #weatherInfoTemplate let-weatherInfoTemplate="dialogRef" let-data>
  <div class="dialog-box card">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <div class="flex-grow-1">
          @if (weatherAddressInfo?.city_name) {
            <div class="fw-semibold">
              {{ weatherAddressInfo?.city_name
              }}{{
                weatherAddressInfo?.state_code
                  ? ", " + weatherAddressInfo?.state_code
                  : ""
              }}
            </div>
          }

          <div>
            {{ data?.selectedDate | customDate: "EEEE d MMM yyyy" }}
          </div>
        </div>
        <div>
          <span (click)="weatherInfoTemplate.close()">
            <i class="fa-solid fa-xmark"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-4">
      <div>
        {{ data?.weatherData?.["Description"] }}
      </div>
      @if (data?.weatherData?.["Condition"]?.icon_id) {
        <div>
          <img
            width="40"
            height="40"
            class="ms-3"
            src="https://raw.githubusercontent.com/visualcrossing/WeatherIcons/58c79610addf3d4d91471abbb95b05e96fb43019/SVG/4th%20Set%20-%20Color/{{
              data?.weatherData?.['Condition']?.icon_id
            }}.svg"
          />
        </div>
      }
    </div>

    <div class="row row-cols-3">
      @for (item of data?.weatherKeys; track item) {
        <dl>
          <dt>{{ item }}</dt>
          <dd>
            {{ data?.weatherData?.[item] }}
          </dd>
        </dl>
      }
    </div>
    <div class="small text-end text-secondary">
      Weather provided by www.visualcrossing.com
    </div>
  </div>
</ng-template>

<ng-template
  #conflictShiftListTemplate
  let-conflictShiftListTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Conflicts
      <span class="float-end" (click)="conflictShiftListTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    @for (
      conflictDate of conflictData | misc: "getDictKeys";
      track conflictDate
    ) {
      <div class="mb-4">
        <div class="text-center fw-bold">
          {{ conflictDate | customDate: "EEEE d MMM y" }}
        </div>
        @for (
          assigneeId of conflictData?.[conflictDate] | misc: "getDictKeys";
          track assigneeId
        ) {
          <div>
            <div class="ps-1 my-2 fw-semibold text-secondary fs-5">
              {{
                conflictData?.[conflictDate]?.[assigneeId]?.assigneeInfo
                  ?.user_name
              }}
            </div>
            <div class="row row-cols-1 row-cols-lg-auto">
              @for (
                job of conflictData?.[conflictDate]?.[assigneeId]?.jobs;
                track job
              ) {
                <ng-container>
                  <div
                    (click)="
                      conflictShiftListTemplateRef.close();
                      openEventDetailPage(job, conflictDate, choiceTemplateRef)
                    "
                    class="conflict-item ms-lg-2"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="fw-bold">
                        {{ job?.shift_info?.start_time }} -
                        {{ job?.shift_info?.end_time }}
                      </div>
                      <div>
                        {{ job?.shift_info | misc: "getTimeDifference" }}
                        Hrs
                      </div>
                    </div>
                    <div class="fw-semibold">
                      <div class="d-flex justify-content-between my-1">
                        <div>
                          {{ job?.job_type_dict?.name | titlecase }}
                          @if (job?.service_type_dict?.name) {
                            <span class="fw-normal">
                              -
                              {{ job?.service_type_dict?.name }}
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="fw-semibold my-1">
                      {{ job?.site_name || job?.name }}
                    </div>
                    <div class="mt-2 d-flex mx-auto">
                      <button
                        class="btn btn-primary w-100"
                        (click)="
                          openTemplate(
                            modifyAssigneeRef,
                            job,
                            'modifyConflictAssignee'
                          );
                          $event.stopImmediatePropagation();
                          conflictShiftListTemplateRef.close()
                        "
                      >
                        Assign to another guard
                      </button>
                    </div>
                  </div>
                </ng-container>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template
  #deleteScheduleTemplate
  let-deleteScheduleTemplate="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="deleteScheduleTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="alert alert-danger text-center fw-bold">
        THIS ACTION CANNOT BE UNDONE!
      </div>
      @if (data?.shift_info?.repeat_type == "once") {
        <div class="alert">Are you sure you want to delete this job?</div>
      } @else {
        @if (data?.shift_info?.repeat_type !== "once") {
          <div>
            <div class="form-group ms-2 mb-5">
              <!-- Radio Group Label, if needed -->
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="deleteOption"
                  id="deleteOption1"
                  [value]="1"
                  [(ngModel)]="shiftRecurranceSelection"
                  [checked]="shiftRecurranceSelection === 1"
                />
                <label class="form-check-label" for="deleteOption1">
                  Only this job
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="deleteOption"
                  id="deleteOption2"
                  [value]="2"
                  [(ngModel)]="shiftRecurranceSelection"
                  [checked]="shiftRecurranceSelection === 2"
                  autocomplete="off"
                />
                <label class="form-check-label" for="deleteOption2">
                  This and all future occurrences (if any)
                </label>
              </div>
            </div>
          </div>
        }
      }
    </div>
    <div class="row row-cols-2">
      <div>
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="deleteScheduleTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div>
        <button
          class="btn btn-lg btn-danger w-100"
          (click)="deleteJobShifts(data); deleteScheduleTemplate.close()"
        >
          Delete Job
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #choiceTemplateRef let-data let-choiceTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      <span class="float-end" (click)="choiceTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="row row-cols-1 gy-2 mt-2 gap-3">
        <div class="col">
          <button
            class="btn btn-lg btn-primary w-100"
            (click)="
              data?.job_type_dict?.type_identity === 4
                ? routeToPatrolJobPage(data)
                : routeToJobPage(data);
              choiceTemplateRef.close()
            "
          >
            Open This Job
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg btn-outline-primary w-100"
            (click)="choiceTemplateRef.close(); openEditScheduleTemplate(data)"
          >
            Edit Schedule
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg btn-success w-100"
            (click)="
              choiceTemplateRef.close();
              openTemplate(modifyAssigneeRef, data, 'modifyAssignee')
            "
          >
            Change Assignee
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modifyAssigneeRef let-data let-modifyAssigneeRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Assign Guard to Shifts
      <span class="float-end" (click)="modifyAssigneeRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-4">
      <gtapp-auto-complete
        [data]="assigneeListData"
        placeHolder="Search/Select Assignee"
        searchKeyword="full_name"
        [initialValue]="selectedAssignee?.full_name"
        [itemTemplate]="assigneeTemplate"
        (inputChanged)="searchAssignees($event)"
        (selected)="selectedAssignee = $event"
        inputId="conflictAssigneeId"
      >
      </gtapp-auto-complete>
      <ng-template #assigneeTemplate let-guard>
        <div>
          {{ guard?.full_name ? guard.full_name : guard.email }}
        </div>
      </ng-template>
    </div>
    @if (!data?.conflictJob) {
      <div class="form-group ms-2 mb-5">
        <!-- Radio Group Label, if needed -->
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="radio"
            name="deleteOption"
            id="deleteOption1"
            [value]="1"
            [(ngModel)]="shiftRecurranceSelection"
            [checked]="shiftRecurranceSelection === 1"
          />
          <label class="form-check-label" for="deleteOption1">
            Only this job
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="deleteOption"
            id="deleteOption2"
            [value]="2"
            [(ngModel)]="shiftRecurranceSelection"
            [checked]="shiftRecurranceSelection === 2"
            autocomplete="off"
          />
          <label class="form-check-label" for="deleteOption2">
            This and all future occurrences (if any)
          </label>
        </div>
      </div>
    }

    <div class="row row-cols-2">
      <div>
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="modifyAssigneeRef.close()"
        >
          Cancel
        </button>
      </div>
      <div>
        <button
          class="btn btn-lg btn-primary w-100"
          (click)="changeAssignee(data); modifyAssigneeRef.close()"
          [disabled]="!selectedAssignee?.id"
        >
          Change Asignee
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #jobDetailTemplate let-job="job" let-date="date">
  <div
    class="scheduled-item bg-secondary-subtle text-black"
    (click)="openEventDetailPage(job, date, choiceTemplateRef)"
  >
    <div class="d-flex justify-content-between">
      <div class="fw-bold">
        @if (!largeView) {
          {{ date | misc: "eventDateGrouping" }}
        }
        {{ job?.shift_info?.start_time }} -
        {{ job?.shift_info?.end_time }}
      </div>
      <div>
        {{ job?.shift_info | misc: "getTimeDifference" }}
        Hrs
      </div>

      @if (
        (job?.job_type_dict?.type_identity === 4 ||
          !job?.status_dict?.status_identity ||
          job?.status_dict?.status_identity < 10) &&
        (job?.shift_info
          | misc: "trashIconIf" : date : isAdmin || isDispatchUser)
      ) {
        <div
          (click)="
            openTemplate(deleteScheduleTemplate, job);
            $event.stopImmediatePropagation()
          "
        >
          <i class="fs-5 fa-solid fa-circle-minus text-danger me-2"></i>
        </div>
      }
    </div>
    @if (job?.job_type_dict?.type_identity === 4) {
      @if (!largeView) {
        <div class="fw-semibold my-1">
          {{ job?.job_type_dict?.name | titlecase }}
          @if (job?.service_type_dict?.name) {
            <span class="fw-normal">
              -
              {{ job?.service_type_dict?.name }}
            </span>
          }
        </div>
      }
      @if (job?.name) {
        <div class="d-flex justify-content-between align-items-center my-2">
          <div class="fw-semibold">
            {{ job?.name }}
          </div>
          @if (job?.checkpoint_count) {
            <div class="fw-semibold me-2">
              <i class="fa-solid fa-location-dot"></i>
              {{ job?.checkpoint_count }}
            </div>
          }
        </div>
      }
    } @else {
      <div class="fw-semibold my-1">
        {{ job?.job_type_dict?.name | titlecase }}
        @if (job?.service_type_dict?.name) {
          <span class="fw-normal">
            -
            {{ job?.service_type_dict?.name }}
          </span>
        }
      </div>
      @if (shiftDataGroupBy !== "site") {
        <div>
          {{ job?.site_name }}
        </div>
      }
      @if (shiftDataGroupBy === "assignee" || !largeView) {
        <div class="text-secondary">
          {{ job?.company_name }}
        </div>
      }
    }
    @if (job?.requires_acceptance) {
      <div class="row row-cols-2 my-3 my-lg-2">
        <div class="col">
          <button
            class="btn btn-success w-100"
            [ngClass]="largeView ? 'btn-sm' : 'btn-md'"
            (click)="
              onJobActionClick('accept', job); $event.stopImmediatePropagation()
            "
          >
            Accept
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-danger w-100"
            [ngClass]="largeView ? 'btn-sm' : 'btn-md'"
            (click)="
              openTemplate(jobDeclineTemplateRef, job);
              $event.stopImmediatePropagation()
            "
          >
            Decline
          </button>
        </div>
      </div>
    }
    @if (isAdmin || isDispatchUser) {
      <div class="d-flex justify-content-between align-items-center">
        @if (job?.assignee_list?.length) {
          @for (assignee of job?.assignee_list; track assignee; let l = $last) {
            <div>
              <div class="my-1 d-flex align-items-center">
                @if (
                  (conflictData
                    | misc: "rosterShiftDictEventDateData" : date)?.[
                    assignee?.id
                  ]?.jobs?.length
                ) {
                  <span
                    class="text-danger fw-bold fs-5 me-2"
                    title="Conflict Detected"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                  >
                    <i class="fa-solid fa-business-time"></i>
                  </span>
                } @else {
                  @if (assignee?.acceptance_status == 1) {
                    <span
                      title="Shift Accepted"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-success fw-bold fs-5 me-2"
                      ><i class="fa-solid fa-circle-check"></i
                    ></span>
                  }
                  @if (assignee?.acceptance_status == 2) {
                    <span
                      title="Pending Acceptance"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      class="text-warning fw-bold fs-5 me-2"
                      ><i class="fa-solid fa-circle-question"></i
                    ></span>
                  }
                }
                @if (shiftDataGroupBy !== "assignee") {
                  <span>
                    {{ assignee?.user_name }}
                  </span>
                }
              </div>
            </div>
          }
        } @else {
          <span
            class="text-danger fw-bold fs-5 me-2"
            title="Unassigned Shift"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
          >
            <i class="fa-solid fa-triangle-exclamation"></i
          ></span>
        }
        @if (
          job?.shift_info
            | misc: "isCurrentOrFutureJob" : date : isAdmin || isDispatchUser
        ) {
          <div>
            <span
              (click)="duplicateShifts(job); $event.stopImmediatePropagation()"
            >
              <i
                class="fa-regular fa-copy text-secondary fs-5 me-2"
                title="Duplicate Shifts"
              ></i>
            </span>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #weatherTemplate let-date="date">
  @if ((weatherData | misc: "getWeatherFromDate" : date)?.Condition?.text) {
    <div
      class="p-0 text-center fw-semibold small-font cursor-pointer border border-1 rounded-1 bg-secondary-subtle text-black"
      (click)="openWeatherTemplate(weatherInfoTemplate, weatherData, date)"
    >
      @if (
        (weatherData | misc: "getWeatherFromDate" : date)?.Condition?.icon_id
      ) {
        <img
          width="28"
          height="28"
          class="me-2"
          src="https://raw.githubusercontent.com/visualcrossing/WeatherIcons/58c79610addf3d4d91471abbb95b05e96fb43019/SVG/4th%20Set%20-%20Color/{{
            (weatherData | misc: 'getWeatherFromDate' : date)?.Condition
              ?.icon_id
          }}.svg"
        />
      }
      {{ (weatherData | misc: "getWeatherFromDate" : date)?.Condition?.text }}
    </div>
  }
</ng-template>

<ng-template #searchTemplateRef let-searchTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Filters
      <span class="float-end" (click)="searchTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="d-flex flex-wrap column-gap-3 row-gap-2 mb-5">
      <div>
        @if (appliedFilters?.jType?.id) {
          <dl class="p-2">
            <dt>Job Type</dt>
            <dd
              class="link-edit"
              (click)="appliedFilters.jType = {}; editField('jType')"
            >
              {{ appliedFilters?.jType?.name }}
            </dd>
          </dl>
        } @else {
          <div class="col-12 form-floating">
            <select
              class="form-control"
              id="jTypeLookupField"
              [ngModel]="appliedFilters?.jType?.name"
              (change)="onJobTypeChange($event)"
            >
              @for (jType of jobTypesDataList; track jType) {
                <option [value]="jType.id">
                  {{ jType?.name }}
                </option>
              }
            </select>
            <label for="jTypeLookupField">Job Type</label>
          </div>
        }
      </div>
      <div>
        @if (appliedFilters?.client?.id) {
          <dl class="p-2">
            <dt>Client</dt>
            <dd
              class="link-edit"
              (click)="appliedFilters.client = {}; editField('client')"
            >
              {{ appliedFilters?.client?.company_name }}
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="clientDropDownList"
            placeHolder="Select Client"
            searchKeyword="company_name"
            [itemTemplate]="clientLookupTemplate"
            (inputChanged)="searchClients($event)"
            (selected)="
              appliedFilters.client = {
                id: $event?.id,
                company_name: $event?.company_name,
              };
              appliedFilters.site = {}
            "
            [enableCloseOption]="true"
            inputId="clientLookupId"
            (fieldCleared)="editField('client')"
            (inputFocused)="inputFocused('client')"
          >
          </gtapp-auto-complete>
          <ng-template #clientLookupTemplate let-item>
            <div>
              {{ item?.company_name }}
            </div>
          </ng-template>
        }
      </div>
      <div>
        @if (appliedFilters?.site?.id) {
          <dl class="p-2">
            <dt>Site</dt>
            <dd
              class="link-edit"
              (click)="appliedFilters.site = {}; editField('site')"
            >
              {{ appliedFilters?.site?.company_name }}
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="siteDropDownList"
            placeHolder="Select Site"
            searchKeyword="company_name"
            [itemTemplate]="siteLookupTemplate"
            (inputChanged)="searchSites($event)"
            (selected)="
              appliedFilters.site = {
                id: $event?.id,
                company_name: $event?.company_name,
              };
              appliedFilters.client = {}
            "
            [enableCloseOption]="true"
            inputId="siteLookupId"
            (fieldCleared)="editField('site')"
            (inputFocused)="inputFocused('site')"
          >
          </gtapp-auto-complete>
          <ng-template #siteLookupTemplate let-item>
            <div>
              {{ item?.company_name }}
            </div>
          </ng-template>
        }
      </div>
      @if (isAdmin || isDispatchUser) {
        <div>
          @if (appliedFilters?.assignee?.id) {
            <dl class="p-2">
              <dt>Assignee</dt>
              <dd
                class="link-edit"
                (click)="appliedFilters.assignee = {}; editField('assignee')"
              >
                {{ appliedFilters?.assignee?.full_name }}
              </dd>
            </dl>
          } @else {
            <gtapp-auto-complete
              [data]="assigneeDropDownList"
              placeHolder="Person"
              searchKeyword="full_name"
              [itemTemplate]="assigneeLookupTemplate"
              (inputChanged)="searchAssignee($event)"
              (selected)="
                appliedFilters.assignee = {
                  id: $event?.id,
                  full_name: $event?.full_name,
                }
              "
              [enableCloseOption]="true"
              inputId="assigneeLookupId"
              (fieldCleared)="editField('assignee')"
              (inputFocused)="inputFocused('assignee')"
            >
            </gtapp-auto-complete>
            <ng-template #assigneeLookupTemplate let-item>
              <div>
                {{ item?.full_name }}
              </div>
            </ng-template>
          }
        </div>
      }
      @if (isAdmin || isDispatchUser) {
        <div>
          <dl class="p-2">
            <dt>Shift Status</dt>
            <div class="d-flex gap-3 flex-wrap">
              <div class="form-check">
                <input
                  [checked]="!appliedFilters?.shiftStatus"
                  class="form-check-input"
                  type="radio"
                  id="allStatus"
                  (change)="appliedFilters.shiftStatus = 0"
                />
                <label class="form-check-label" for="allStatus">
                  Show All
                </label>
              </div>
              <div class="form-check">
                <input
                  [checked]="appliedFilters?.shiftStatus == 1"
                  class="form-check-input"
                  type="radio"
                  id="assignedStatus"
                  (change)="appliedFilters.shiftStatus = 1"
                />
                <label class="form-check-label" for="assignedStatus">
                  Assigned
                </label>
              </div>
              <div class="form-check">
                <input
                  [checked]="appliedFilters?.shiftStatus == 2"
                  class="form-check-input"
                  type="radio"
                  id="pendingStatus"
                  (change)="appliedFilters.shiftStatus = 2"
                />
                <label class="form-check-label" for="pendingStatus">
                  Pending
                </label>
              </div>
              <div class="form-check">
                <input
                  [checked]="appliedFilters?.shiftStatus == 3"
                  class="form-check-input"
                  type="radio"
                  id="unAssignedStatus"
                  (change)="appliedFilters.shiftStatus = 3"
                />
                <label class="form-check-label" for="unAssignedStatus">
                  Unassigned
                </label>
              </div>
            </div>
          </dl>
        </div>
      }
    </div>
    <div class="row row-cols-2">
      <div>
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="
            searchTemplateRef.close(); appliedFilters = {}; filterRosterShifts()
          "
        >
          {{
            (appliedFilters | misc: "getDictKeys")?.length
              ? "Reset Filters"
              : " Cancel"
          }}
        </button>
      </div>
      <div>
        <button
          class="btn btn-lg btn-primary w-100"
          (click)="filterRosterShifts(); searchTemplateRef.close()"
        >
          Apply Filter
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #jobDeclineTemplateRef
  let-data
  let-jobDeclineTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Decline Shift
      <span class="float-end" (click)="jobDeclineTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        placeholder="Decline Reason [160 chars]"
        cols="20"
        rows="4"
        wrap="hard"
        maxlength="160"
        type="text"
        [(ngModel)]="declineReason"
        id="declineReasonField"
      ></textarea>
      @if (declineReason) {
        <span
          class="input-group-text"
          (click)="
            declineReason = ''; clearAndFocusTextBox('declineReasonField')
          "
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobDeclineTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="!declineReason"
          (click)="
            onJobActionClick('decline', data); jobDeclineTemplateRef.close()
          "
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #sendShiftNotificationTemplate
  let-data
  let-sendShiftNotificationTemplate="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      Publish Shifts
      <span class="float-end" (click)="sendShiftNotificationTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="mb-2">
      Send an email to notify the following guard(s) they have allocated shifts
      to accept.
    </div>
    @for (assignee of data; track assignee) {
      <div class="mb-4">
        <ul class="mb-0">
          <li>
            {{ assignee?.assignee_name }} [{{ assignee?.assignee_email }}]
          </li>
        </ul>
      </div>
    }
    @if (data?.length) {
      <div>
        Recipients:
        <span class="fs-6">{{ data?.length }}</span>
      </div>
    }

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="sendShiftNotificationTemplate.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-success btn-lg w-100"
          [disabled]="!data?.length"
          (click)="sendShiftNotificationTemplate.close(true)"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>
